import { PriceConfig } from '~/lib/atom/types/price-config';

import { event } from '..';
import { assertDuplicateWithinWindow } from '../assert-duplicate-within-window';
import { getItems, RequestedProducts } from '../get-items';
import { logEventWarning } from '../log';

export const viewItem = (priceConfig: PriceConfig) => {
  // Ignore any duplicate events within a 1 second window
  const isDuplicateEvent = assertDuplicateWithinWindow(1000);

  return async (requestedProducts: RequestedProducts[]) => {
    if (isDuplicateEvent(requestedProducts)) {
      logEventWarning('view_item');

      return;
    }

    const items = await getItems(requestedProducts, priceConfig);

    event({
      type: 'view_item',
      payload: {
        currency: priceConfig.currencyCode,
        value: items.reduce((acc, item) => item.price * item.quantity + acc, 0),
        items,
      },
    });
  };
};
